export default __webpack_public_path__ + "static/media/annex8.a1bf8cee.png";